<template>
		<MainLayout>
			<div class="container">
				<div class="box">
					<b-button class="float-right" variant="primary" @click="newReservation" >{{$t('bookings.newRes')}}</b-button>
					<h2 class="inline-heading">{{$t('global.bookings')}}</h2>
					<hr>
					<b-form @submit.prevent="() => { $root.$emit('bv::refresh::table', 'reservations-index-list') } ">
						<b-row>
							<b-form-group class="col-md-2" label="Res ID">
								<b-form-input size="sm" :class="{'active-filter':filters.id}" v-model="filters.id" type="number" />
							</b-form-group>
							<b-form-group class="col-md-2" :label="$t('bookings.clientName')">
								<b-form-input size="sm" :class="{'active-filter':filters.clientFullName}" v-model="filters.clientFullName" type="text" />
							</b-form-group>
							<b-form-group class="col-md-4" :label="$t('bookings.airports')">
								<multiselect
									:class="{'active-filter':filters.airport.length>0}"
									v-model="filters.airport"
									:options="airportsOpts"
									group-label="group"
									group-values="options"
									group-select
									multiple
									label="text"
									track-by="value"
									:placeholder="$t('global.all')"
									:option-height="10"
									taggable
								/>
							</b-form-group>
							<b-form-group class="col-md-4" :label="$t('bookings.destinations')">
								<multiselect
									:class="{'active-filter':filters.destination.length>0}"
									v-model="filters.destination"
									:options="destinationsOpts"
									group-label="group"
									group-values="options"
									group-select
									multiple
									label="text"
									track-by="value"
									:placeholder="$t('global.all')"
									taggable
								/>
							</b-form-group>
						</b-row>
						<b-row>
							<b-form-group class="col-md-2" :label="$t('bookings.salesReference')">
								<b-form-input size="sm" :class="{'active-filter':filters.salesChannelReference}" v-model="filters.salesChannelReference" type="text" />
							</b-form-group>
							<!-- <b-form-group class="col-md-2" :label="$t('bookings.referenceId')">
								<b-form-input size="sm" :class="{'active-filter':filters.supplierReference}" v-model="filters.supplierReference" type="text" />
							</b-form-group> -->
							<b-form-group class="col-md-3" :label="$t('bookings.serviceType')">
								<multiselect
									:class="{'active-filter':filters.serviceType.length>0}"
									v-model="filters.serviceType"
									:options="serviceTypesOpts"
									group-label="group"
									group-values="options"
									group-select
									multiple
									label="text"
									track-by="value"
									:placeholder="$t('global.all')"
									taggable
								/>
							</b-form-group>
							<b-form-group class="col-md-2" :label="$t('bookings.Accepted')">
								<b-form-select size="sm" v-model="filters.supplierConfirmation" :options="supplierConfirmationOpts" />
							</b-form-group>
							<b-form-group class="col-md-2" :label="$t('bookings.origin')">
								<b-form-select :class="{'active-filter':filters.serviceOrigin}" size="sm" v-model="filters.serviceOrigin" :options="serviceOriginsOpts" />
							</b-form-group>
							<b-form-group class="col-md-3" :label="$t('bookings.serviceStatus')">
								<multiselect
									:class="{'active-filter':filters.status.length>0}"
									v-model="filters.status"
									:options="statusOpts"
									group-label="group"
									group-values="options"
									group-select
									multiple
									label="text"
									track-by="value"
									:placeholder="$t('global.all')"
									taggable
								/>
							</b-form-group>
						</b-row>
						<b-row>
							<b-form-group class="col-md-5" >
								<b-form-row>
									<b-col>
										{{$t('bookings.serviceDateFrom')}}
										<b-form-datepicker
											:locale="$root.store.state.currentUser.lang"
											:class="{'active-filter':filters.pickupStartDate}"
											reset-button
											size="sm"
											v-model="filters.pickupStartDate"
										/>
									</b-col>
									<b-col>
										{{$t('bookings.serviceDateTo')}}
										<b-form-datepicker
											:locale="$root.store.state.currentUser.lang"
											:class="{'active-filter':filters.pickupEndDate}"
											reset-button
											size="sm"
											v-model="filters.pickupEndDate"
										/>
									</b-col>
								</b-form-row>
							</b-form-group>
							<b-form-group class="col-md-5" >
								<b-form-row>
									<b-col>
										{{$t('bookings.cancelDateFrom')}}
										<b-form-datepicker
											:locale="$root.store.state.currentUser.lang"
											:class="{'active-filter':filters.cancelationStartDate}"
											reset-button
											size="sm"
											v-model="filters.cancelationStartDate"
										/>
									</b-col>
									<b-col>
										{{$t('bookings.cancelDateTo')}}
										<b-form-datepicker
											:locale="$root.store.state.currentUser.lang"
											:class="{'active-filter':filters.cancelationEndDate}"
											reset-button
											size="sm"
											v-model="filters.cancelationEndDate"
										/>
									</b-col>
								</b-form-row>
							</b-form-group>
							<b-form-group class="col-md-2" :label="$t('bookings.tripType')">
								<b-form-select :class="{'active-filter':filters.trip}" size="sm" v-model="filters.trip" :options="tripOpts" />
							</b-form-group>
						</b-row>
						<b-row>
							<b-form-group class="col-md-12 text-right mt-2" >
								<b-button :disabled="exportLoading" class="mr-2" variant="warning"  @click="exportXLS">
									<span v-if="!exportLoading">{{$t('bookings.export')}} XLS</span>
									<span v-else><b-spinner small></b-spinner> {{$t('bookings.exporting')}}...</span>
								</b-button>
								<b-button class="btn-middle" @click="filters = {...defaultFilters}; $root.$emit('bv::refresh::table', 'reservations-index-list')" variant="info" >{{$t('global.clean')}}</b-button>
								<b-button type="submit" variant="primary" >{{$t('global.search')}}</b-button>
							</b-form-group>
						</b-row>
					</b-form>
					<hr>
					<h5>
						<b-badge
							v-for="(aux,i) in $root.auxVars.transportServiceStatusOpts"
							:key="i"
							:variant="aux.class"
							class="mr-2"
							size=""
							>
							{{$t(`bookings.serviceStatusOpts.${aux.value}`)}}
						</b-badge>
					</h5>
					<AjaxTableReservations
						id="reservations-index-list"
						ref="childtable"
						:showSelectAll="showSelectAll"
						:filters="filtersClean"
						:columns="filteredColumns"
						:selected-items.sync="itemsSelected"
						:itemsFilter="itemsFilter"
						:sort-by.sync="sortBy"
						:sort-desc.sync="sortDesc"
						resource="transport-services"
						responsive
						:res-view="resView"
					>

					</AjaxTableReservations>
					<b-row>
						<b-form-group  v-if="showSelectAll" class="col-md-4">
							<b-button type="submit" variant="warning" class="mr-2" @click="showAssignConfirmationModal">
								<span>{{ $t('global.ajaxTable.assignConfirmation') }}</span>
							</b-button>
						</b-form-group>
						<b-form-group  v-if="!showSelectAll" class="col-md-4"></b-form-group>
						<b-form-group class="col-md-8 text-right mt-2" >
							<b-button type="submit" variant="primary" class="mr-2" @click="toggleMassiveAssign">
								<span v-if="!showSelectAll">{{ $t('global.ajaxTable.massiveOperationsOn') }}</span>
								<span v-else>{{ $t('global.ajaxTable.massiveOperationsOff') }}</span>
							</b-button>
						</b-form-group>
					</b-row>
				</div>
			</div>
			<Single
				ref="single"
				:model-id.sync="modelId"
				:show.sync="showSingleModal"
				@onCopyRes="copyCurrentRes"
				operated-by="supplier"
				/>
			<AssignConfirmationModal
				@cleanIndices="cleanSelectedIndices"
				:selected="itemsSelected"
				:itemValid="selecAsigValid">
			</AssignConfirmationModal>
			<vue-snotify></vue-snotify>
		</MainLayout>
</template>

<script>
import MainLayout from '../layout/MainLayout.vue'
import Multiselect from 'vue-multiselect'
import Single from './Single'
import AssignConfirmationModal from './AssignConfirmationModal.vue'
import AjaxTableReservations from './AjaxTableReservations'

export default {
	components: {MainLayout, Multiselect, Single, AssignConfirmationModal, AjaxTableReservations},
	data() {
		let defaultFilters = {
			id: '',
			clientFullName: '',
			destination: [],
			airport: [],
			serviceType: [],
			pickupStartDate: '',
			pickupEndDate: '',
			creationStartDate: '',
			creationEndDate: '',
			cancelationStartDate: '',
			cancelationEndDate: '',
			serviceOrigin: null,
			trip: 0,
			status: [{value: 'active', text: this.$t(`bookings.serviceStatusOpts.active`)}],
			salesChannelReference: '',
			supplierReference: '',
			supplierConfirmation: null,
		}
		return {
			loading: true,
			itemsSelected: [],
			modelId: -1,
			showSingleModal: false,
			exportLoading: false,
			showSelectAll: false,
			sortBy: 'reservationId',
			sortDesc: true,
			filters: {...defaultFilters},
			defaultFilters: {...defaultFilters},
			modelColumns: [
				{key: 'reservationId', label: 'Res ID', sortable: true, tdClass: 'one-line-fix'},
				{key: 'clientName', label: this.$t('bookings.client')},
				{key: 'clientEmail', label: this.$t('global.email')},
				{key: 'clientPhone', label: this.$t('global.phone')},
				{key: 'pickup', label: 'Pickup'},
				{key: 'dropoff', label: 'Dropoff'},
				{key: 'passengers', label: this.$t('bookings.passengers')},
				{key: 'pickupDatetime', label: this.$t('bookings.pickupDate'), sortable: true, tdClass: 'one-line-fix'},
				{key: 'supplierServiceType.name', label: this.$t('bookings.serviceType')},
				{key: 'salesChannelReference', label: this.$t('bookings.salesReference'), thClass: 'one-line-fix'},
				{key: 'trip', label: this.$t('bookings.trip')},
				{key: 'transportUnit', label: this.$t('bookings.transportUnit')},
				{key: 'userDriver', label: this.$t('bookings.driver')},
				{key: 'salesChannel', label: this.$t('bookings.salesChannel')},
				// {key:'trackingStatus',label:this.$t('bookings.trackingStatus')},
				{key: 'supplierStatus', label: this.$t('bookings.accepted'), tdClass: 'text-center'},
				{key: 'actions', label: this.$t('bookings.actions')}
			],
			serviceOriginsOpts: [
				{value: null, text: this.$t('global.all')},
				{value: 'supplier', text: this.$t('bookings.selfService')},
				{value: 'sc', text: this.$t('bookings.shuttleCentralService')},
			],
			supplierConfirmationOpts: [
				{value: null, text: this.$t('bookings.AcceptedOptions.all')},
				{value: 'pending', text: this.$t('bookings.AcceptedOptions.pending')},
				{value: 'confirmed', text: this.$t('bookings.AcceptedOptions.confirmed')},
			],
			selecAsigValid: [],
		}
	},
	computed: {
		filteredColumns() {
			let aux = [];
			if (this.showSelectAll) {
				aux.push({key: 'selected', label: ''});
			}
			aux = aux.concat(this.modelColumns);
			return aux;
		},
		filtersClean() {
			return {
				id: this.filters.id,
				clientFullName: this.filters.clientFullName,
				destination: this.filters.destination.map(aux => aux.value),
				airport: this.filters.airport.map(aux => aux.value),
				serviceType: this.filters.serviceType.map(aux => aux.value),
				pickupStartDate: this.filters.pickupStartDate,
				pickupEndDate: this.filters.pickupEndDate,
				creationStartDate: this.filters.creationStartDate,
				creationEndDate: this.filters.creationEndDate,
				cancelationStartDate: this.filters.cancelationStartDate,
				cancelationEndDate: this.filters.cancelationEndDate,
				trip: this.filters.trip,
				status: this.filters.status.map(aux => aux.value),
				salesChannelReference: this.filters.salesChannelReference,
				serviceOrigin: this.filters.serviceOrigin,
				supplierReference: this.filters.supplierReference,
				supplierConfirmation: this.filters.supplierConfirmation,
			}
		},
		destinationsOpts() {
			// eslint-disable-next-line
			this.$root.$i18n.locale
			return [{group: this.$t('global.selectAll'), options: this.$root.auxVars.destinationsOpts}]
		},
		airportsOpts() {
			// eslint-disable-next-line
			this.$root.$i18n.locale
			return [{group: this.$t('global.selectAll'), options: this.$root.auxVars.airportsOpts}]
		},
		statusOpts() {
			// eslint-disable-next-line
			this.$root.$i18n.locale
			return [{
				group: this.$t('global.selectAll'),
				options: this.$root.auxVars.transportServiceStatusOpts.map(opt => ({
					value: opt.value,
					text: this.$t(`bookings.serviceStatusOpts.${opt.value}`)
				}))
			}]
		},
		tripOpts() {
			// eslint-disable-next-line
			this.$root.$i18n.locale
			let aux = [...this.$root.auxVars.tripOpts]
			aux.unshift({value: 0, text: this.$t('global.all')})
			return aux
		},
		serviceTypesOpts() {
			// eslint-disable-next-line
			this.$root.$i18n.locale
			return [{group: this.$t('global.selectAll'), options: this.$root.auxVars.serviceTypesOpts}]
		},
		statusLabels() {
			let vars = this.$root.auxVars.transportServiceStatusOpts
			let opts = {}
			for (let i = 0; i < vars.length; i++) {
				opts[vars[i].value] = vars[i].text
			}
			return opts
		},
		trackingStatusLabels() {
			// eslint-disable-next-line
			this.$root.$i18n.locale
			let vars = this.$root.auxVars.transportServiceTrackingStatusOpts
			let opts = {}
			for (let i = 0; i < vars.length; i++) {
				opts[vars[i].value] = this.$t(`bookings.trackingStatusOpts.${vars[i].value}`)
			}
			return opts
		},
		serviceStatusVariants() {
			let aux = {}
			this.$root.auxVars.transportServiceStatusOpts.map(status => {
				aux[status.value] = status.class
			})
			return aux
		},
	},
	methods: {
		copyCurrentRes() {
			const aux = this.modelId
			this.modelId = -1
			this.$refs.single.copyFromId(aux)
		},
		newReservation() {
			this.modelId = -1
			this.showSingleModal = true
		},
		itemsFilter(items) {
			return items.map(item => ({...item, _rowVariant: this.serviceStatusVariants[item.status]}));
		},
		toggleMassiveAssign() {
			if (!this.showSelectAll) {
				this.$refs.childtable.getChildtableRef().showMax();
			}
			this.showSelectAll = !this.showSelectAll;
		},
		showAssignConfirmationModal() {
			this.itemAsigValid(this.$refs.childtable.getChildtableRef().selected);
			this.$root.$emit('bv::show::modal', "modal-assign-confirmation-view", event.target);
		},
		itemAsigValid(selected) {
			this.selecAsigValid = []
			for (let i in this.$refs.childtable.getChildtableRef().data) {
				if (selected.includes(this.$refs.childtable.getChildtableRef().data[i].id)) {
					if (this.$refs.childtable.getChildtableRef().data[i].supplierConfirmation === "pending") {
						this.selecAsigValid.push(this.$refs.childtable.getChildtableRef().data[i].id);
					}
				}
			}
		},
		cleanSelectedIndices() {
			this.itemsSelected = [];
			this.selecAsigValid = [];
		},
		exportXLS() {
			this.exportLoading = true
			this.$root.api.get(`/transport-services/export`, {
				params: {
					sortBy: this.sortBy,
					sortOrder: this.sortDesc ? 'desc' : 'asc',
					lang: this.$root.store.state.currentUser.lang,
					filters: this.filtersClean,
				},
				responseType: "blob"
			}).then((res) => {
				let blob = new Blob([res.data], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
				});
				let url = window.URL.createObjectURL(blob);
				let a = document.createElement("a");
				a.href = url;
				a.download = "TransportServices.xlsx";
				a.click();
				window.URL.revokeObjectURL(url);
				this.exportLoading = false
			}).catch(error => {
				this.$root.handleRequestError(error)
				this.exportLoading = false
			});
		},
		resView(item) {
			this.$root.store.setSelectedServiceNumber(null);
			this.modelId = item.reservationId
			this.showSingleModal = true
			// this.$refs['single'].loadModel(item.reservationId)
		},
		iconSupplierConfirmation(status) {
			let icon = "";
			let classe = "";
			switch (status) {
				case "pending":
					icon = 'warning'
					classe = 'warning'
					break
				case "confirmed":
					icon = 'check_circle';
					classe = 'success';
					break;
				case "rejected":
					icon = 'dangerous'
					classe = 'danger'
					break;
			}
			return {icon: icon, class: classe};

		}
	},
	mounted() {
		this.$root.auxVars.loadResourcesOpts({
			vm: this,
			resourceNames: ['serviceTypesOpts', 'airportsOpts', 'destinationsOpts']
		});
		if (localStorage.getItem('reservation-filters')) {
			try {
				this.filters = {...this.defaultFilters, ...JSON.parse(localStorage.getItem('reservation-filters'))}
			} catch (e) {
				localStorage.removeItem('reservation-filters');
			}
		}
		try{
			if(!this.$root.isEmpty(this.$route.params.serviceNumber)){
				this.filters = {...this.defaultFilters};//LIMPIAMOS LOS FILTROS PARA PONER EL ID DE RESERVA
				let serviceNumber      = this.$route.params.serviceNumber;
				let serviceNumberParts = serviceNumber.split("-");
				let reservationId      = serviceNumberParts[0];
				this.filters = {...this.filters,...{id:reservationId}}
				//console.log(this.$root.store.state.selectedServiceNumber)
				const itemData = {
					reservationId:parseInt(reservationId),
					serviceNumber:serviceNumber
				};
				this.resView(itemData);
				try{
					this.$root.store.setSelectedServiceNumber(itemData.serviceNumber);
				}catch(err){
					console.log(err);
				}
			}
		}catch(err){
			console.log(err)
		}
	},
	watch: {
		filters: {
			handler(newFilters) {
				localStorage.setItem('reservation-filters', JSON.stringify(newFilters))
			},
			deep: true,
		},
	},
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style >
	.one-line-fix{
		white-space: nowrap;
	}
	.multiselect__tags{
		max-height: 150px;
		overflow-y: auto;
		overflow-y: auto;
	}
	.active-filter{
		border: 2px solid #021D3E;
	}
	.snotifyToast__title {
		font-size: 1.5em;
	}
	.inline-heading {
		display: inline;
	}
	.inline-button {
		margin-bottom: 10px;
	}

</style>

<style scoped>
.btn-middle {
	margin-right: 8px;
}
</style>
